import { graphql } from 'react-relay/hooks';

export const subscription = graphql`
    query subscriptionQuery {
        subscription {
            hasSidesPerVariant
        }
    }
`;
